export default () => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="black"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M26.4985 13.0766C26.4985 5.8546 20.6782 0 13.4985 0C6.31883 0 0.498535 5.8546 0.498535 13.0766C0.498535 19.6035 5.25245 25.0134 11.4673 25.9944V16.8566H8.1665V13.0766H11.4673V10.1957C11.4673 6.91835 13.4081 5.10806 16.3776 5.10806C17.7999 5.10806 19.2876 5.36346 19.2876 5.36346V8.58153H17.6483C16.0334 8.58153 15.5298 9.58953 15.5298 10.6237V13.0766H19.1353L18.5589 16.8566H15.5298V25.9944C21.7446 25.0134 26.4985 19.6035 26.4985 13.0766Z"
      fill="inherit"
    />
  </svg>
);
